<ng-container *ngLet="dataContext | async">
  @if (isLoading) {
    <div id="featuredPartsHome_div_IsLoading">
      <h5 class="ps-4">Loading featured products...</h5>
    </div>
  }
  @if (!isLoading) {
    <ng-container id="featuredPartsHome_div_IsNotLoading" class="w-100">
      <part-card-list title="Featured Products" [parts]="featuredParts" [partType]="featuredProductType"></part-card-list>
    </ng-container>
  }
</ng-container>
